import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation, ViewChildren, QueryList } from '@angular/core';
import { Campaign3Service } from '../../services/campaign3.service';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Campaign3Info, Campaign3Store, JsonSchemaTouchpointPropertiesFormProperties, MessageInstanceObject, MessageInstanceObjectTypes, MessageInstanceRule, MessageInstanceRuleDetail, MessageInstanceRuleTypes, StoreMessageOChannel, Touchpoint } from '../../models/campaign-3.model';
import { ConfirmationService, Dialog, MessageService } from 'primeng/primeng';
import { AreaGeo, Campaign3Wizard, Group, Insegna } from '../../models/campaign-3-touchpoint.model';
import { FormFields } from '../../components/form-fields/form-fields.component';
import { Observable } from 'rxjs';
import { ActionType, MessageInstanceRuleObjectTypeResponse } from '../../models/campaign-3-info-base.model';
import * as moment from 'moment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { KvJsonFormSchemaComponent } from 'app/views/administration/apps-config/json-schema-form/kv-json-form-schema.component';


@Component({
  selector: 'app-campaign-3-touchpoint',
  templateUrl: './campaign-3-touchpoint.component.html',
  styleUrls: ['./campaign-3-touchpoint.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3TouchpointComponent implements OnInit {

  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() storeList: Array<any> = [];
  @Input() formSchema: any;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() areeList: Array<AreaGeo> = [];
  @Input() groupList: Array<Group> = [];
  @Input() insegneList: Array<Insegna> = [];
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() touchpointListEmission: Array<Touchpoint> = [];
  @Input() touchpointListFruition: Array<Touchpoint> = [];
  @Input() actionTypesList: Array<ActionType> = [];
  @Input() actionTypeCode: string = null;
  @Input() barcodeAnteprima: string = null;




  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();



  //accumulatori
  @ViewChildren('wizard') wizardComponent: QueryList<FormFields>;

  layoutDefault = {
    form_schema: null,
    form_values: null
  };

  dragInfo = {
    dragStart: {
      index: null,
      type: null,
      offline_online: null
    },
    dragEnd: {
      index: null,
      type: null,
      offline_online: null
    }
  }

  disabled = {
    anteprima: true
  }

  imagePath: SafeResourceUrl = null;
  showPreview = false;
  showPreviewError: string;

  wizardList: Array<Campaign3Wizard> = [];

 /*  show = {
    form: false,
    modalWizard: false,
    modalStores: false,
    modalLayoutDefault: false,
    modalForRules: false

  } */
 show = {
  form: false,
  modalWizard: false,
  modalStoresEmission: false,
  modalStoresFruition: false,
  modalLayoutDefault: false,
  modalForRules: false
};


  fieldModel = {
    layoutDefaultSchema: null,
    layoutDefaultValue: null,
    tipoEntitaEmissione: null,
    tipoEntitaFruizione: null
  }

  storesChanged: boolean = false;

list = {
  stores: {
    emission: [],
    fruition: []
  },
  wizards: []
};


  rules_OL_emission: Array<MessageInstanceRule> = [];
  rules_WZ_emission: Array<MessageInstanceRule> = [];

  rules_OL_fruition: Array<MessageInstanceRule> = [];
  rules_WZ_fruition: Array<MessageInstanceRule> = [];

  //regoleTouchpoint
  ruleObjectTypeResponse: MessageInstanceRuleObjectTypeResponse | null = null;
  futureScopeRule: string;
  touchpointid: number;
  ruleToEdit: MessageInstanceRule | null = null;
  rules_TR_emission: Array<MessageInstanceRule> = [];
  rules_TR_fruition: Array<MessageInstanceRule> = [];
  targetScope : string;

  switch = {
    E: {
      ON: false,
      OFF: false
    },
    F: {
      ON: false,
      OFF: false,
      AS_EMISSION_ON: false,
      AS_EMISSION_OFF: false
    },
    offlineImportaComeEmissione: false,
    onlineImportaComeEmissione: false
  }

  touchpoints = {
    E: {
      OFF: [],
      ON: []
    },
    F: {
      OFF: [],
      ON: []
    }
  }


  currentInfo = {
    type: null,
    index: null,
    offline_online: null
  }
  messageCode: string = "";





  constructor(
    private srvCampaign3: Campaign3Service,
    private srvCalTranslate: CalendarTranslateService,
    private srvNotify: MessageService,
    private _sanitizer: DomSanitizer,
    private translate: TranslateService,
      private confirmationService: ConfirmationService
  ) {

  }
  ngOnInit() {
    this.reloadInfoTouchpoint();


  }
  checkAnteprimaEnabled() {

    let actionTypeCode = this.actionTypesList.find(x => x.shortCode == this.actionTypeCode);

    if (
      this.messageCode &&
      this.messageInstanceObject.startEmissionDate &&
      this.messageInstanceObject.endEmissionDate &&
      this.messageInstanceObject.flgRolling &&
      this.messageInstanceObject.startFruitionDate &&
      this.messageInstanceObject.endEmissionDate &&
      this.messageInstanceObject.flgCouponingMethod &&
      this.barcodeAnteprima &&
      actionTypeCode && actionTypeCode.code
    ) {
      this.disabled.anteprima = false;
    }
    else {
      this.disabled.anteprima = true;
    }
  }
  setRulesData() {
    this.checkForTouchpointStores("E");
    this.checkForTouchpointStores("F");

    this.checkForTouchpointPriority("E");
    this.checkForTouchpointPriority("F");

    //EMISSIONE
    let rulesEmission_OL = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "OL").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);
    let rulesEmission_WZ = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "WZ").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);
    if (rulesEmission_OL && rulesEmission_OL.messageInstanceRuleDetail && rulesEmission_OL.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesEmission_OL.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TOCH").id) {

          let tp_E_ON = this.touchpoints.E.ON.find(x => x.ochannel_id == mird.objectId);


          if (tp_E_ON)
            tp_E_ON["active"] = true;
          if (tp_E_ON && mird.objectJson) {

            if (mird.objectPriorty) {
              tp_E_ON["priority"] = mird.objectPriorty;
            }
            if (mird.objectValue != "default") {

              tp_E_ON.layoutValue = Object.assign({}, mird.objectJson);
              tp_E_ON.layoutOwnSet = true;
            }
            else if (mird.objectValue == "default" && tp_E_ON.acceptLayoutDefault == true && mird.objectJson) {

              tp_E_ON.layoutValue = Object.assign({}, mird.objectJson);
              tp_E_ON.layoutDefaultSet = true;
            }
            else {

              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.inconsistent_layout_data')
              });


              console.log("TOUCHPOINT:");
              console.log("ID --> ", tp_E_ON.ochannel_id);
              console.log("LAYOUT_VALUE --> ", tp_E_ON.layoutValue.toString());
              console.log("RULE OBJECT TYPE (is default string present?) --> ", mird.objectValue.toString());
              console.log("ACCEPT DEFAULT --> ", tp_E_ON.acceptLayoutDefault.toString());
            }

          }
          let tp_E_OFF = this.touchpoints.E.OFF.find(x => x.ochannel_id == mird.objectId);
          if (tp_E_OFF) {
            tp_E_OFF["active"] = true;
          }

          if (tp_E_OFF && mird.objectJson) {
            if (mird.objectValue != "default") {
              tp_E_OFF.layoutValue = Object.assign({}, mird.objectJson);
              tp_E_OFF.layoutOwnSet = true;
            }
            else if (mird.objectValue == "default" && tp_E_OFF.acceptLayoutDefault == true && mird.objectJson) {
              tp_E_OFF.layoutValue = Object.assign({}, mird.objectJson);
              tp_E_OFF.layoutDefaultSet = true;
            }
            else {

              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.inconsistent_layout_data')
              });



              console.log("TOUCHPOINT:");
              console.log("ID --> ", tp_E_OFF.ochannel_id);
              console.log("LAYOUT_VALUE --> ", tp_E_OFF.layoutValue.toString());
              console.log("RULE OBJECT TYPE (is default string present?) --> ", mird.objectValue.toString());
              console.log("ACCEPT DEFAULT --> ", tp_E_OFF.acceptLayoutDefault.toString());
            }

          }
        }
      }
    };

    if (rulesEmission_WZ && rulesEmission_WZ.messageInstanceRuleDetail && rulesEmission_WZ.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesEmission_WZ.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TWIZ").id) {
          let tp_E_ON = this.touchpoints.E.ON.find(x => x.ochannel_id == mird.objectValue);
          if (tp_E_ON && mird.objectValue && mird.objectId) {
            tp_E_ON.wizardModel = (tp_E_ON.wizardList && tp_E_ON.wizardList.lenght > 0) ? tp_E_ON.wizardList.find(x => x.id == mird.objectId) : null;
            if (mird.objectPriorty) {
              tp_E_ON["priority"] = mird.objectPriorty;
            }
          }

          let tp_E_OFF = this.touchpoints.E.OFF.find(x => x.ochannel_id == mird.objectValue);
          if (tp_E_OFF && mird.objectValue && mird.objectId) {
            tp_E_OFF.wizardModel = (tp_E_OFF.wizardList && tp_E_OFF.wizardList.lenght > 0) ? tp_E_OFF.wizardList.find(x => x.id == mird.objectId) : null;
          }
        }
      }
    };

    //FRUIZIONE
    let rulesFruition_OL = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "OL").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION);
    let rulesFruition_WZ = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "WZ").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION);


    if (rulesFruition_OL && rulesFruition_OL.messageInstanceRuleDetail && rulesFruition_OL.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesFruition_OL.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TOCH").id) {
          let tp_F_ON = this.touchpoints.F.ON.find(x => x.ochannel_id == mird.objectId);
          if (tp_F_ON) {
            tp_F_ON["active"] = true;
          }

          if (tp_F_ON && mird.objectJson) {

            if (mird.objectPriorty) {
              tp_F_ON["priority"] = mird.objectPriorty;
            }

            if (mird.objectValue != "default") {
              tp_F_ON.layoutValue = Object.assign({}, mird.objectJson);
              tp_F_ON.layoutOwnSet = true;
            }
            else if (mird.objectValue == "default" && tp_F_ON.acceptLayoutDefault == true && mird.objectJson) {
              tp_F_ON.layoutValue = Object.assign({}, mird.objectJson);
              tp_F_ON.layoutDefaultSet = true;
            }
            else {

              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.inconsistent_layout_data')
              });



            }

          }

          let tp_F_OFF = this.touchpoints.F.OFF.find(x => x.ochannel_id == mird.objectId);

          if (tp_F_OFF) {
            tp_F_OFF["active"] = true;
          }
          if (tp_F_OFF && mird.objectJson) {

            if (mird.objectValue != "default") {
              tp_F_OFF.layoutValue = Object.assign({}, mird.objectJson);
              tp_F_OFF.layoutOwnSet = true;
            }
            else if (mird.objectValue == "default" && tp_F_OFF.acceptLayoutDefault == true && mird.objectJson) {
              tp_F_OFF.layoutValue = Object.assign({}, mird.objectJson);
              tp_F_OFF.layoutDefaultSet = true;
            }
            else {

              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.inconsistent_layout_data')
              });


            }

          }
        }
      }
    };

    if (rulesFruition_WZ && rulesFruition_WZ.messageInstanceRuleDetail && rulesFruition_WZ.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesFruition_WZ.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TWIZ").id) {
          let tp_F_ON = this.touchpoints.F.ON.find(x => x.ochannel_id == mird.objectValue);
          if (tp_F_ON && mird.objectId) {

            tp_F_ON.wizardModel = (tp_F_ON.wizardList && tp_F_ON.wizardList.lenght > 0) ? tp_F_ON.wizardList.find(x => x.id == mird.objectId) : null;

            if (mird.objectPriorty) {
              tp_F_ON["priority"] = mird.objectPriorty;
            }
          }

          let tp_F_OFF = this.touchpoints.F.OFF.find(x => x.ochannel_id == mird.objectValue);
          if (tp_F_OFF && mird.objectId && mird.objectValue) {
            tp_F_OFF.wizardModel = (tp_F_OFF.wizardList && tp_F_OFF.wizardList.lenght > 0) ? tp_F_OFF.wizardList.find(x => x.id == mird.objectId) : null;
          }
        }
      }
    };


    const rulesEmission_TR = this.messageInstanceObject.messageInstanceRule
      .filter(x => x.ruleType === 'TR' && x.ruleScope === 'emission');

    const rulesFruition_TR = this.messageInstanceObject.messageInstanceRule
      .filter(x => x.ruleType === 'TR' && x.ruleScope === 'fruition');

    this.rules_TR_emission = rulesEmission_TR;
    this.rules_TR_fruition = rulesFruition_TR;

    console.log('emission', this.rules_TR_emission);
    console.log('fruition', this.rules_TR_fruition);



    /* const flatList = this.flattenTouchpoints(this.touchpoints);

    this.assignRulesToTouchpoints(rulesEmission_TR, this.touchpoints, flatList);
     */

  }

  /*
  assignRulesToTouchpoints(
    rules: MessageInstanceRule[],
    touchpoints: { E: { OFF: any[]; ON: any[] }, F: { OFF: any[]; ON: any[] } },
    allTouchpoints: any[]   // questa deve essere un array!
  ) {
    if (!rules || !rules.length) return;

    rules.forEach(rule => {
      const scopeKey = rule.ruleScope === 'emission' ? 'E' :
                       rule.ruleScope === 'fruition' ? 'F' : null;
      if (!scopeKey) return;

      const tp = allTouchpoints.find(t => t.ochannel_id === rule.ochannelId);
      if (!tp) return;

      const channelKey = tp.type === 'OFF' ? 'OFF' : 'ON';

      touchpoints[scopeKey][channelKey].push(rule);
    });

    console.log(this.touchpoints.F.ON)
  }
  flattenTouchpoints(touchpoints: { E: { OFF: any[]; ON: any[] }, F: { OFF: any[]; ON: any[] } }) {
    const list: any[] = [];

    (['E', 'F'] as const).forEach(scope => {
      (['OFF', 'ON'] as const).forEach(channel => {
        touchpoints[scope][channel].forEach(tp => {
          list.push({
            ...tp,
            scope,
            type: channel // aggiungo OFF/ON
          });
        });
      });
    });

    return list;
  }
   */




  checkForTouchpointPriority(type: string) {
    this.touchpoints[type].ON.sort((a, b) => {
      if (a.priority == null && b.priority == null) {
        return 0;
      }
      if (a.priority == null) {
        return 1;
      }
      if (b.priority == null) {
        return -1;
      }
      return b.priority - a.priority;
    });
  }

  checkForTouchpointUniqueWizard(type: string, online_offline: string, index: number) {
    //se il touchpoint ha un solo elemento wizard ed è un certificatore, allora selezionalo
    let tp = this.touchpoints[type][online_offline][index];

    if (tp.wizardList && tp.certifier == this.srvCampaign3.touchpointCertifier.YES && tp.wizardList.length == 1) {
      tp.wizardModel = tp.wizardList[0];
    }

  };
  onDragStart(event: DragEvent, type: string, offline_online, index: number) {

    this.dragInfo.dragStart.type = type;
    this.dragInfo.dragStart.offline_online = offline_online;
    this.dragInfo.dragStart.index = index;


  }
  changeTouchpointPosition<T>(array: T[], indexStart: number, indexEnd: number): void {
    // Verifica che gli indici siano all'interno dei limiti dell'array
    if (indexStart < 0 || indexStart >= array.length || indexEnd < 0 || indexEnd >= array.length) {
      console.error("Indici non validi.");
      return;
    }
    // Scambia gli elementi nelle posizioni indexStart e indexEnd
    const temp = array[indexStart];
    array[indexStart] = array[indexEnd];
    array[indexEnd] = temp;
  }
  onDrop(event: DragEvent, type: string, offline_online, index: number) {
    this.dragInfo.dragEnd.type = type;
    this.dragInfo.dragEnd.offline_online = offline_online;
    this.dragInfo.dragEnd.index = index;

    if (this.dragInfo.dragStart.type == this.dragInfo.dragEnd.type && this.dragInfo.dragStart.offline_online == this.dragInfo.dragEnd.offline_online && this.dragInfo.dragStart.index != this.dragInfo.dragEnd.offline_online) {
      this.changeTouchpointPosition(this.touchpoints[type][offline_online], this.dragInfo.dragStart.index, this.dragInfo.dragEnd.index);
    }
    this.dragInfo.dragStart.type = null;
    this.dragInfo.dragStart.offline_online = null;
    this.dragInfo.dragStart.index = null;
    this.dragInfo.dragEnd.type = null;
    this.dragInfo.dragEnd.offline_online = null;
    this.dragInfo.dragEnd.index = null;
    event.preventDefault();

  }
  // Funzione per gestire l'evento dragover
  onDragOver(event: DragEvent) {
    event.preventDefault();
  }
  setAllFields(arrayTp: Array<Touchpoint>) {
    for (let tp of arrayTp) {
      tp["layoutSchema"] = null;//usato per registrare lo scheletro, il formschema del layout del singolo touchpoint
      tp["layoutValue"] = null;//usato per registrare il valore del layout del singolo touchpoint
      tp["active"] = false; //usato per indicare che quel touchpoint e attivo e quindi si possono definire negozi,layout e wizard

      //tp["negoziModel_previous"]=[]; //usato per registrare i negozi selezionati
      tp["negoziModel"] = []; //usato per registrare i negozi selezionati
      tp["negoziModified"] = false; //usato quando si fanno modifiche sui negozi, per invocare o meno una delete o una post

      tp["wizardModel"] = null; //usato per registrare la scelt del wizard
      tp["acceptLayoutDefault"] = tp.default_layout == this.srvCampaign3.touchpointAcceptDefault.YES ? true : false;//usato  per indicare che il layout accetta un default
      tp["layoutDefaultSet"] = false;//usato
      tp["layoutOwnSet"] = false; //usato quando viene settato il layout del singolo touchpoint
      tp["priority"] = null; //usato per ordinare i touchpoint secondo priorità
      tp["valid"] = true;
    }
  }
  loadStoresForTouchpoints(type: string, online_offline: string) {
    let arrayTouchPoints = []
    for (let tp of this.touchpoints[type][online_offline]) {
      arrayTouchPoints.push()
    }
  }
  checkTouchpointsValid(): boolean {
    let valid = true;
    //EMISSIONE OFFLINE
    for (let tp of this.touchpoints.E.OFF) {
      if (tp.active) {
        /*
        condizioni di validità:
        - è stato definito almeno un negozio
        - è stato definito il layoutValue, oppure se non è stato definito il layoutValue va bene il layout di default se il touchpoint lo accetta
        - se c'è una wizardList, se è stato definito il wizard
        */

        if ((tp.negoziModel && tp.negoziModel.length > 0) && ((tp.layoutValue || (!tp.layoutValue && tp.layoutOwnSet)))) {
          tp.valid = true;
        }
        else {
          tp.valid = false;
          valid = false;
        }
      }
    }

    //EMISSIONE ONLINE
    for (let tp of this.touchpoints.E.ON) {

      if (tp.active) {
        /*
        condizioni di validità:
        - è stato definito il layoutValue, oppure se non è stato definito il layoutValue va bene il layout di default se il touchpoint lo accetta
        - se c'è una wizardList, se è stato definito il wizard
        */
        if ((tp.layoutValue || ((!tp.layoutValue && tp.layoutOwnSet) || tp.layoutDefaultSet))) {
          tp.valid = true;
        }
        else {
          tp.valid = false;
          valid = false;
        }
      }
    }

    //FRUIZIONE OFFLINE
    for (let tp of this.touchpoints.F.OFF) {
      if (tp.active) {

        if ((tp.negoziModel && tp.negoziModel.length > 0)) {
          tp.valid = true;


        }
        else {
          tp.valid = false;
          valid = false;
        }
      }
    }

    return valid;
  }
  deleteDefaultFromSchema(formSchema: any) {
    let prop = formSchema.properties;
    for (let key in prop) {
      delete prop[key].default;
    }
  }
  deleteFormFromValues(formValues: any) {
    for (let key in formValues) {
      if (key == "form") delete formValues[key];
    }
  }
onStoresSelected(stores: any[], type: string) {

  if (type === 'E') {
    this.show.modalStoresEmission = false;
  } else {
    this.show.modalStoresFruition = false;
  }

  const info = this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index];

  info.negoziModel = [...stores];
  info.negoziModified = true;

  this.storesChanged = true;
}

onStoresCancel(type: 'E' | 'F') {
  if (type === 'E') {
    this.show.modalStoresEmission = false;
  } else {
    this.show.modalStoresFruition = false;
  }
}

  onClickLayoutDefault() {
    if (!this.readOnly) {
      this.resetCurrentInfo();
      this.layoutDefault.form_schema = Object.assign({}, this.fieldModel.layoutDefaultSchema);
      this.layoutDefault.form_values = this.fieldModel.layoutDefaultValue;
      this.show.modalLayoutDefault = true;
    }
  }
  checkForSwitch(type: string, online_offline: string) {
    const touchpoints = this.touchpoints[type][online_offline];
    for (let index = 0; index < touchpoints.length; index++) {

      let mirId = this.miRuleTypesList.find(x => x.code == "OL").id;
      let mirdId = this.miObjectTypesList.find(x => x.code == "TOCH").id;

      let ruleScope = (type == "E") ? this.srvCampaign3.ruleScopesEmissionFruition.EMISSION : (type == "F" ? this.srvCampaign3.ruleScopesEmissionFruition.FRUITION : null);
      if (ruleScope) {

        let ruleFound = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == mirId && x.ruleScope == ruleScope);

        if (ruleFound) {
          let ruleDetailFound = ruleFound.messageInstanceRuleDetail.find(x => x.objectTypeId == mirdId && (x.objectId == touchpoints[index].ochannel_id));

          if (ruleDetailFound) {
            this.switch[type][online_offline] = true;
            this.onClickTouchpointNameButton(type, online_offline, index, true);
          }
        }
      }
    }
  }
  onChangeSwitch(type: string, online_offline: string, switchValue: boolean) {
    for (let tp of this.touchpoints[type][online_offline]) {
      tp.active = false;
    }
  }
  setCurrentInfo(type: string, online_offline: string, index: number) {
    this.currentInfo.type = type;
    this.currentInfo.offline_online = online_offline;
    this.currentInfo.index = index;
  }
  resetCurrentInfo() {
    this.currentInfo.type = null;
    this.currentInfo.offline_online = null;
    this.currentInfo.index = null;
  }
onClickNegoziBtn(type: string, online_offline: string, index: number) {
  this.setCurrentInfo(type, online_offline, index);

  const storeListToUse = (type === 'E')
    ? this.list.stores.emission
    : this.list.stores.fruition;
 
  // reset
  for (let store of storeListToUse) {
    store["rowSelected"] = false;
  }

  let selectedStores = this.touchpoints[type][online_offline][index].negoziModel;

  if (selectedStores && selectedStores.length > 0) {
    for (let store of selectedStores) {
      let storeFromList = storeListToUse.find(x => x.id == store.id);
      if (storeFromList) {
        storeFromList["rowSelected"] = true;
      }
    }
  }

  if (type === 'E') {
    this.show.modalStoresEmission = true;
  } else {
    this.show.modalStoresFruition = true;
  }
}

  onClickLayoutBtn(type: string, online_offline: string, index: number) {

    //schema del singolo touchpoint, restituito dalla getTouchPointListForCouponing
    let schema = Object.assign({}, this.touchpoints[type][online_offline][index].form_values);

    //valori da visualizzare nello schema del layout, solo nel caso non siano già stati definiti nelle regole (e quindi in this.touchpoints[type][online_offline][index]["layoutValue"] che ho valorizzato prima a seconda se ci stava una regola o meno)

    this.setCurrentInfo(type, online_offline, index);
    if (schema) {
      this.layoutDefault.form_schema = schema;
      this.layoutDefault.form_values = this.touchpoints[type][online_offline][index]["layoutValue"] ? this.touchpoints[type][online_offline][index]["layoutValue"] : null;
      this.show.modalLayoutDefault = true;
    }
    else {
      if (this.touchpoints[type][online_offline][index].acceptLayoutDefault == true) {
        //se non ha uno schema proprio e accetta il default, fai vedere lo schema del layout di default
        this.layoutDefault.form_schema = Object.assign({}, this.fieldModel.layoutDefaultSchema);
        this.layoutDefault.form_values = this.touchpoints[type][online_offline][index]["layoutValue"] ? this.touchpoints[type][online_offline][index]["layoutValue"] : null;
      }
      else {

        this.srvNotify.add({
          severity: 'info',
          summary: 'info',
          detail: this.translate.instant('campaign.no_layout_schema')
        });



      }
    }
  }

  //todo
  //Alla pressione effettua la chiamata al servizio per recepire informazioni su come costruire il form
  //se però troviamo una regola ce la salviamo in ruleToEdit e la passiamo al popup
  onCreateRulesButton(type: string, online_offline: string, index: number, tp: any) {
    console.log('onCreateRulesButton called with:');
    console.log('type:', type);
    console.log('online_offline:', online_offline);
    console.log('index:', index);
    console.log('tp:', tp);

    this.srvCampaign3.getMessageInstanceRuleObjectTypeList(tp.ochannel_id).subscribe(
      data => {
        if (data) {
          this.ruleObjectTypeResponse = data;

          // 🔹 Cerca se esiste già una regola per questo touchpoint
          const existingRule = this.getRuleByTouchpoint(type, tp.ochannel_id);
          // 🔹 Passo al figlio la regola (se esiste) o null
          this.ruleToEdit = existingRule || null;

          this.futureScopeRule = type;
          this.touchpointid = tp.ochannel_id;
          this.targetScope = online_offline;

          // 🔹 Apro il popup
          this.show.modalForRules = true;

        }
      }
    );
  }

  getRuleByTouchpoint(scope: string, ochannelId: number): MessageInstanceRule | null {
    const array = scope === 'emission' ? this.rules_TR_emission : this.rules_TR_fruition;
    return array.find(r => r.ochannelId === ochannelId) || null;
  }

  onClickTouchpointNameButton(type: string, online_offline: string, index: number, isForCheck: boolean = false) {

    if (this.switch[type][online_offline] && (isForCheck || !this.readOnly)) {
      this.setCurrentInfo(type, online_offline, index);
      this.touchpoints[type][online_offline][index]["active"] = !this.touchpoints[type][online_offline][index]["active"];

      if (this.touchpoints[type][online_offline][index]["active"] == true) {
        /*** gestione priorità dei touchpoint (solo caso online: in caso offline le regole verranno create con priorità -99) ***/
        if (online_offline == "ON") {
          this.assignPrioritiesToTouchpints(type);
          this.checkForTouchpointPriority(type);
        }
      }
      else {
        this.touchpoints[type][online_offline][index].priority = null;
        /*** gestione priorità dei touchpoint (solo caso online: in caso offline le regole verranno create con priorità -99) ***/
        if (online_offline == "ON") {
          this.assignPrioritiesToTouchpints(type);
          this.checkForTouchpointPriority(type);
        }
      }

      var self = this;
      setTimeout(function () {
        self.checkForTouchpointUniqueWizard(type, online_offline, index);
      }, 100);


    }
  }

  assignPrioritiesToTouchpints(type: string) {
    let activeTouchpoints = this.touchpoints[type].ON.filter(tp => tp.active === true);
    let totalActive = activeTouchpoints.length;
    let count = 0;

    for (let tp of this.touchpoints[type].ON) {
      if (tp.active) {
        tp.priority = totalActive - count;
        count++;
      }
    }
  }

  /*   assignPrioritiesToTouchpints(type: string){
      let count = 0;
      for(let tp of this.touchpoints[type].ON){
        if(tp.active){

          tp.priority = this.touchpoints[type].ON.filter(tp => tp.active === true).length - count;
        }
        count++;
      }
    } */
  onChangeWizard(type: string, offline_online: string, index: number, wizard: any) {
    this.setCurrentInfo(type, offline_online, index);
  }
  onClickSearchWizard(type: string, offline_online: string, index: number) {
    this.setCurrentInfo(type, offline_online, index);
    this.wizardList = (this.touchpoints[type][offline_online][index].wizardList && this.touchpoints[type][offline_online][index].wizardList.length > 0) ? Object.assign([], this.touchpoints[type][offline_online][index].wizardList) : [];
    this.show.modalWizard = true;
  }
  onWizardSelected(wizard: any) {
    this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].wizardModel = Object.assign({}, wizard);
    this.show.modalWizard = false;
  }
  onClickAnnulla_ModalWizard() {
    this.resetCurrentInfo();
    this.show.modalWizard = false;
  }
  saveLayout(formValues: any) {

    if (this.currentInfo && this.currentInfo.index != null && this.currentInfo.index > -1) {
      this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].layoutValue = formValues;

      if (this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].form_schema) {
        this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].layoutOwnSet = true;
        this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].layoutValue = formValues;
      }
      else {
        if (this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].acceptLayoutDefault == true) {
          this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].layoutDefaultSet = true;
          this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].layoutValue = formValues;
        }
      }
      this.show.modalLayoutDefault = false;
    }
    else {
      //caso layout di default
      this.fieldModel.layoutDefaultValue = formValues;
      this.checkAllTouchpointForDefault();
      this.show.modalLayoutDefault = false;
    }
  }
  checkAllTouchpointForDefault() {

    /*
    viene chiamato nel momento in cui si definisce il layout di default e succede la seguente cosa:
    - si scorre la lista di touchpoint.
    1.1) per ogni touchpoint: verifica se è stato definito un valore per il layout di quel touchpoint.
    1.2) se non è stato definito nessun valore, allora controlla se accetta il default da apposito parametro.
    1.3) Nel caso quel parametro indica che accetta il default allora assegnagli una regola considerando come valore json il valore del layout di default, a prescindere se quel touchpoint abbia o no uno schema di layout proprio (differente da quello di default).
    In questo caso non creiamo subito la regola, la creiamo solamente in fase di salvataggio, ci limitiamo a dire "ok viene settato il default"
    */

    for (let tp of this.touchpoints.E.ON) {
      if (!tp.layoutOwnSet && tp.acceptLayoutDefault) {
        tp.layoutDefaultSet = true;
      }
    }
    for (let tp of this.touchpoints.E.OFF) {

      if (!tp.layoutOwnSet && tp.acceptLayoutDefault) {
        tp.layoutDefaultSet = true;

      }
    }
  }
  isAtLeastOneTouchpoint() {
    let valid = false;
    let oneEmissionTouchpoint = false;
    let oneFruitionTouchpoint = false;

    for (let tp of this.touchpoints["E"].OFF) {
      if (tp.active && tp.valid) {
        oneEmissionTouchpoint = true;
      }
    }

    for (let tp of this.touchpoints["E"].ON) {
      if (tp.active && tp.valid) {
        oneEmissionTouchpoint = true;
      }
    }

    for (let tp of this.touchpoints["F"].OFF) {
      if (tp.active && tp.valid) {
        oneFruitionTouchpoint = true;
      }
    }
    for (let tp of this.touchpoints["F"].ON) {
      if (tp.active && tp.valid) {
        oneFruitionTouchpoint = true;
      }
    }

    if (oneEmissionTouchpoint == true && oneFruitionTouchpoint == true) {
      valid = true;
    }

    return valid;
  }
  performValidationTouchpoint(): boolean {
    let valid = true;
    const errors: string[] = []; // Array per raccogliere i messaggi di errore

    // Controllo se i touchpoints sono validi
    const areTouchpointsValid = this.checkTouchpointsValid();


    // Valida i touchpoints e il layout di default
    if (!areTouchpointsValid) {
      // Se né i touchpoints né il layout di default sono validi
      valid = false;
      errors.push(
        this.translate.instant(
          'campaign.invalid_touchpoints_or_layout_default_required'
        )
      );
    }
    // Controllo se c'è almeno un touchpoint per emissione e uno per fruizione
    if (!this.isAtLeastOneTouchpoint()) {
      valid = false;
      errors.push(
        this.translate.instant('campaign.emission_fruition_touchpoints_required')
      );
    }

    // Mostra i messaggi di errore, se presenti
    if (errors.length > 0) {
      errors.forEach(error => {
        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: error,
          life: 5000,
        });
      });
    }

    return valid;
  }


  createRules() {

    /*** per ogni touchpoint di EMISSIONE, solo se però valorizzato, viene creata:
     *  - una regola per il wizard, di tipo WZ, con un dettaglio di tipo TWIZ
     *  - una regola per il layout, di tipo OL, con un dettaglio di tipo TOCH
     */

    /*** per ogni touchpoint di FRUIZIONE, solo se però valorizzato, viene creata:
     *  - una regola per il wizard, di tipo WZ, con un dettaglio di tipo TWIZ
     *  - da requisito non ci sono regole di layout per la fruizione
     */
    this.rules_OL_emission = [];
    //  this.rules_WZ_emission = [];

    this.rules_OL_fruition = [];
    // this.rules_WZ_fruition = [];

    /*  let ruleWZ_emission = new MessageInstanceRule();
     ruleWZ_emission.messageInstanceId = this.messageInstanceObject.id;
     ruleWZ_emission.ruleTypeId = this.miRuleTypesList.find(x=>x.code == "WZ").id;
     ruleWZ_emission.ruleType = "WZ";
     ruleWZ_emission.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
     ruleWZ_emission.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION; */

    let ruleOL_emission = new MessageInstanceRule();
    ruleOL_emission.messageInstanceId = this.messageInstanceObject.id;
    ruleOL_emission.ruleTypeId = this.miRuleTypesList.find(x => x.code == "OL").id;
    ruleOL_emission.ruleType = "OL";
    ruleOL_emission.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
    ruleOL_emission.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION;
    //touchpoint emissione offline (definibili obbligatorieamente negozi, layout e eventualmente wizard)
    let index_E_OFF = 0;
    for (let tp of this.touchpoints.E.OFF) {
      if (tp.active == true && ((tp.negoziModel && tp.negoziModel.length > 0) || tp.layoutValue || (tp.acceptLayoutDefault == true && this.fieldModel.layoutDefaultValue))) {
        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TOCH").id;
        mird.objectTypeCode = "TOCH"
        mird.objectId = tp.ochannel_id;
        mird.objectPriorty = -99;

        if (tp.layoutValue) {
          mird.objectJson = tp.layoutValue;
        }
        else if (tp.acceptLayoutDefault == true && this.fieldModel.layoutDefaultValue) {
          mird.objectValue = "default";
          mird.objectJson = this.fieldModel.layoutDefaultValue;
          ruleOL_emission.messageInstanceRuleDetail.push(mird);
        }
        ruleOL_emission.messageInstanceRuleDetail.push(mird);
        /*   if(tp.wizardModel && tp.wizardModel.id>0 ){
            let mird = new MessageInstanceRuleDetail();
            mird.objectTypeCode = "TWIZ";
            mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TWIZ").id;
            mird.objectId = tp.wizardModel.id;
            mird.objectValue = tp.ochannel_id;
            ruleWZ_emission.messageInstanceRuleDetail.push(mird);
          } */
      }
      index_E_OFF++;
    }

    //touchpoint emissione online (definibili obbligatorieamente layout e eventualmente wizard)
    let index_E_ON = 0;
    for (let tp of this.touchpoints.E.ON) {

      if (tp.active == true && ((tp.negoziModel && tp.negoziModel.length > 0) || tp.layoutValue || (tp.acceptLayoutDefault == true && this.fieldModel.layoutDefaultValue))) {

        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TOCH").id;
        mird.objectTypeCode = "TOCH"
        mird.objectId = tp.ochannel_id;
        mird.objectPriorty = tp.priority;

        if (tp.layoutValue) {

          mird.objectJson = tp.layoutValue;
          ruleOL_emission.messageInstanceRuleDetail.push(mird);
        }
        else if (tp.acceptLayoutDefault == true && this.fieldModel.layoutDefaultValue) {

          mird.objectValue = "default";
          mird.objectJson = this.fieldModel.layoutDefaultValue;
          ruleOL_emission.messageInstanceRuleDetail.push(mird);
        }

        /*  if(tp.wizardModel && tp.wizardModel.id>0 ){
           let mird = new MessageInstanceRuleDetail();
           mird.objectTypeCode = "TWIZ";
           mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TWIZ").id;
           mird.objectId = tp.wizardModel.id;
           mird.objectValue = tp.ochannel_id;
           ruleWZ_emission.messageInstanceRuleDetail.push(mird);
         } */
      }
      index_E_ON++;
    }


    /*    let ruleWZ_fruition = new MessageInstanceRule();
       ruleWZ_fruition.messageInstanceId = this.messageInstanceObject.id;
       ruleWZ_fruition.ruleTypeId = this.miRuleTypesList.find(x=>x.code == "WZ").id;
       ruleWZ_fruition.ruleType = "WZ";
       ruleWZ_fruition.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
       ruleWZ_fruition.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION; */

    let ruleOL_fruition = new MessageInstanceRule();
    ruleOL_fruition.messageInstanceId = this.messageInstanceObject.id;
    ruleOL_fruition.ruleTypeId = this.miRuleTypesList.find(x => x.code == "OL").id;
    ruleOL_fruition.ruleType = "OL";
    ruleOL_fruition.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
    ruleOL_fruition.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION;


    //touchpoint fruizione offline (definibili obbligatorieamente negozi ed eventualmente wizard)
    let index_F_OFF = 0;
    for (let tp of this.touchpoints.F.OFF) {

      if (tp.active == true && (tp.negoziModel && tp.negoziModel.length > 0)) {
        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TOCH").id;
        mird.objectTypeCode = "TOCH"
        mird.objectId = tp.ochannel_id;
        mird.objectPriorty = -99;
        ruleOL_fruition.messageInstanceRuleDetail.push(mird);
      }

      /*  if(tp.wizardModel && tp.wizardModel.id>0 ){
         let mird = new MessageInstanceRuleDetail();
         mird.objectTypeCode = "TWIZ";
         mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TWIZ").id;
         mird.objectId = tp.wizardModel.id;
         mird.objectValue = tp.ochannel_id;
         ruleWZ_fruition.messageInstanceRuleDetail.push(mird);
       } */
      index_F_OFF++;
    }

    //touchpoint fruizione offline (definibili obbligatorieamente eventualmente i soli wizard)
    let index_F_ON = 0;
    for (let tp of this.touchpoints.F.ON) {

      if (tp.active == true && (tp.negoziModel && tp.negoziModel.length > 0)) {
        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TOCH").id;
        mird.objectTypeCode = "TOCH"
        mird.objectId = tp.ochannel_id;
        mird.objectPriorty = tp.priority;

        ruleOL_fruition.messageInstanceRuleDetail.push(mird);
      }

      /*    if(tp.wizardModel && tp.wizardModel.id>0 ){
           let mird = new MessageInstanceRuleDetail();
           mird.objectTypeCode = "TWIZ";
           mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TWIZ").id;
           mird.objectId = tp.wizardModel.id;
           mird.objectValue = tp.ochannel_id;
           ruleWZ_fruition.messageInstanceRuleDetail.push(mird);
         } */
      index_F_ON++;
    }

    if (ruleOL_emission.messageInstanceRuleDetail.length > 0) {
      this.rules_OL_emission.push(ruleOL_emission);
    }
    /*   if(ruleWZ_emission.messageInstanceRuleDetail.length>0){
        this.rules_WZ_emission.push(ruleWZ_emission);
      } */
    if (ruleOL_fruition.messageInstanceRuleDetail.length > 0) {
      this.rules_OL_fruition.push(ruleOL_fruition);
    }
    /*   if(ruleWZ_fruition.messageInstanceRuleDetail.length>0){
        this.rules_WZ_fruition.push(ruleWZ_fruition);
      } */


  }
  setAllTouchpointActive(type: string, online_offline: string) {
    this.switch[type][online_offline] = true;
    var self = this;
    setTimeout(function () {
      for (let i = 0; i < self.touchpoints[type][online_offline].length; i++) {
        self.onClickTouchpointNameButton(type, online_offline, i);
      }
    }, 100);

  }

  private isWithinInterval(storeStart: Date, storeEnd: Date, intervalStart: Date, intervalEnd: Date): boolean {
  return storeStart <= intervalEnd && storeEnd >= intervalStart;
}

reloadInfoTouchpoint() {

  this.show.form = false;
  var self = this;

  setTimeout(function () {

self.fieldModel.layoutDefaultSchema = self.messageInstanceObject.layoutDefaultFormSchema;

if (self.ui_mode == self.srvCampaign3.ui_modes.EDIT) {
  self.fieldModel.layoutDefaultValue = self.messageInstanceObject.layoutValue;
}

// -----------------------
// DATE
// -----------------------
const emStartRaw = self.messageInstanceObject.startEmissionDate;
const frStartRaw = self.messageInstanceObject.startFruitionDate;

const emStart = emStartRaw ? new Date(emStartRaw) : null;
const frStart = frStartRaw ? new Date(frStartRaw) : null;

if (emStart) {
  console.log("[DATE] Emission start:", emStart);
} else {
  console.log("[DATE] Emission start: NULL → nessun filtro applicato");
}

if (frStart) {
  console.log("[DATE] Fruition start:", frStart);
} else {
  console.log("[DATE] Fruition start: NULL → nessun filtro applicato");
}

const totalStores = self.storeList.length;

// -----------------------
// FILTRO EMISSIONE
// -----------------------
if (emStart) {
  self.list.stores.emission = self.storeList.filter(store => {
    const storeStart = new Date(store.date_start);
    return storeStart <= emStart;
  });

  console.log(
    `[EMISSIONE] Filtrati da ${totalStores} -> ${self.list.stores.emission.length} (limite ${emStart.toISOString().slice(0,10)})`
  );
} else {
  self.list.stores.emission = [...self.storeList];
  console.log(`[EMISSIONE] Nessun filtro applicato (${totalStores} negozi)`);
}

// -----------------------
// FILTRO FRUITION
// -----------------------
if (frStart) {
  self.list.stores.fruition = self.storeList.filter(store => {
    const storeStart = new Date(store.date_start);
    return storeStart <= frStart;
  });

  console.log(
    `[FRUITION] Filtrati da ${totalStores} -> ${self.list.stores.fruition.length} (limite ${frStart.toISOString().slice(0,10)})`
  );
} else {
  self.list.stores.fruition = [...self.storeList];
  console.log(`[FRUITION] Nessun filtro applicato (${totalStores} negozi)`);
}

    // Set dei touchpoint
    self.setAllFields(self.touchpointListEmission);
    self.setAllFields(self.touchpointListFruition);

    self.touchpoints.E.OFF = self.touchpointListEmission.filter(x => x.flg_offline == '1');
    self.touchpoints.E.ON  = self.touchpointListEmission.filter(x => x.flg_offline != '1');

    self.touchpoints.F.OFF = self.touchpointListFruition.filter(x => x.flg_offline == '1');
    self.touchpoints.F.ON  = self.touchpointListFruition.filter(x => x.flg_offline != '1');

    self.show.form = true;

    var self2 = self;

    // EDIT → ricarica le regole
    if (self.ui_mode == self.srvCampaign3.ui_modes.EDIT) {
      setTimeout(function () {
        self2.setRulesData();
      }, 100);
    }

    // CREATE → attiva touchpoint fruizione offline
    if (self2.ui_mode == self.srvCampaign3.ui_modes.CREATE) {
      self2.setAllTouchpointActive("F", "OFF");
    }

  }, 100);

}

  checkForTouchpointStores(type: string) {
    for (let tp of this.touchpoints[type].OFF) {
      tp.negoziModel = [];
      if (this.messageInstanceObject.storeMessageOChannel && this.messageInstanceObject.storeMessageOChannel.length > 0) {
        for (let smo of this.messageInstanceObject.storeMessageOChannel) {
          //mi vengono restituiti tutti i negozi, anche quelli con flg_state = '1', perciò devo far vedere come selezionati solo quelli con flg_state = '0'
          let store = this.storeList.find(x => x.id == smo.storeId && smo.storeType == type && smo.flg_state == "0");
          if (store) {
            tp.negoziModel.push(Object.assign({}, store));
          }

        }
      }
    }
    this.checkForSwitch(type, "OFF");
    this.checkForSwitch(type, "ON");
  }
  erroreRecuperoTouchpoint(res) {
    console.log("ERRORE NEGOZI PER TOUCHPOINT: ", JSON.stringify(res));

    this.srvNotify.add({
      severity: 'error',
      summary: this.translate.instant('common.error'),
      detail: this.translate.instant('campaign.error_retrieving_touchpoint_stores')
    });



  }


  onChangeSwitchAsEmissionOff_new() {


    //se non ho nessun touchpoint attivo in offline non attivo la funzione
    if (this.touchpoints.E.OFF[0].active) {
      for (let tp_E of this.touchpoints.E.OFF) {
        let tpFruition = this.touchpoints.F.OFF.find(x => x.ochannel_id == tp_E.ochannel_id);
        if (tpFruition) {
          //tpFruition.layoutValue = Object.assign({},tp_E.layoutValue);
          tpFruition.negoziModel = Object.assign([], tp_E.negoziModel);
          //tpFruition.wizardModel =  Object.assign({},tp_E.wizardModel);
          //tpFruition.layoutDefaultSet = tp_E.layoutDefaultSet ? true : false;
          tpFruition.active = tp_E.active == true ? true : false;
        }
      }
    } else {

      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.no_active_offline_touchpoint')
      });



    }


  }

  /*
    onChangeSwitchAsEmissionOff(switchValue: boolean){
      if(switchValue == true){
        if(this.switch.E.OFF){
          this.switch.F.OFF = true;
        }

        for(let tp_E of this.touchpoints.E.OFF){
          let tpFruition = this.touchpoints.F.OFF.find(x=>x.ochannel_id == tp_E.ochannel_id);
          if(tpFruition){
            //tpFruition.layoutValue = Object.assign({},tp_E.layoutValue);
            tpFruition.negoziModel =  Object.assign([],tp_E.negoziModel);
            //tpFruition.wizardModel =  Object.assign({},tp_E.wizardModel);
            //tpFruition.layoutDefaultSet = tp_E.layoutDefaultSet ? true : false;
            tpFruition.active = tp_E.active == true ? true : false;
          }
        }

        var self = this;
        setTimeout(function(){
          self.switch.F.AS_EMISSION_OFF = false;
        },100);
      }

    } */
  onChangeSwitchAsEmissionOn(switchValue: boolean) {
    if (switchValue == true) {
      if (this.switch.E.ON) {
        this.switch.F.ON = true;
      }

      for (let tp_E of this.touchpoints.E.ON) {
        let tpFruition = this.touchpoints.F.ON.find(x => x.ochannel_id == tp_E.ochannel_id);
        if (tpFruition) {
          //tpFruition.layoutValue = Object.assign({},tp_E.layoutValue);
          tpFruition.negoziModel = Object.assign([], tp_E.negoziModel);
          //tpFruition.wizardModel =  Object.assign({},tp_E.wizardModel);
          //tpFruition.layoutDefaultSet = tp_E.layoutDefaultSet ? true : false;
          tpFruition.active = tp_E.active == true ? true : false;
        }
      }

      var self = this;
      setTimeout(function () {
        self.switch.F.AS_EMISSION_ON = false;
      }, 100);
    }
    /*
    else{
      for(let tp_F of this.touchpoints.F.ON){
        if(tp_F){
          tp_F.layoutValue = null;
          tp_F.negoziModel =  [];
          tp_F.wizardModel =  null;
          tp_F.active = false;
        }
      }
    }
    */
  }


  //LO TENGO SOLO PERCHE' CI HO MESSO TANTO A SCRIVERLO, LA GESTIONE TUTTAVIA E' CAMBIATA, RIMUOVERE AL MOMENTO OPPORTUNO
  saveStoresForTouchpoints_OLD_2(type: string) {

    /*
    *  Per ogni touchpoint (solo per quelli offline, per quelli online non si definiscono negozi) verifica se ci sono state modifiche ai negozi.
    *  Se ci sono state modifiche allora fai una delete dei negozi "vecchi" e fai delle post per i negozi nuovi.
    *  Poi i touchpoint appena salvati diventeranno quelli "vecchi" per garantire continuità nelle future operazioni sui negozi.
    */

    for (let tp of this.touchpoints[type].OFF) {

      if (tp.active && tp.negoziModified == true) {
        //negozi modificati

        const observablesDelete: Observable<any>[] = [];
        const observablesAdd: Observable<any>[] = [];

        //faccio prima un array di observables per le DELETE dei negozi vecchi (se esistenti)
        if (tp.negoziModel_previous && tp.negoziModel_previous.length > 0) {

          for (let store of tp.negoziModel_previous) {

            if (store.smoid > 0) {
              const observableDel = this.srvCampaign3.deteleTouchpointStores(store.smoid);
              observablesDelete.push(observableDel);
            }
          }
        }

        //dopo la delete faccio un array di observables per la POST per aggiungere i negozi nuovi
        if (tp.negoziModel && tp.negoziModel.length > 0) {
          if (tp.negoziModel && tp.negoziModel.length > 0) {
            for (let store of tp.negoziModel) {
              const observable = this.srvCampaign3.saveTouchpointStores(this.messageInstanceObject.id,
                tp.ochannel_id,
                type, store.id);
              observablesAdd.push(observable);
            }
          }
        }

        //a questo punto effettuo le chiamate
        Observable.zip(...observablesDelete, ...observablesAdd).subscribe(results => {
          if (!results) {
            console.log(JSON.stringify(results));

            this.srvNotify.add({
              severity: 'error',
              summary: this.translate.instant('common.error'),
              detail: this.translate.instant('campaign.error_saving_touchpoint_stores')
            });



          }

          for (let store of tp.negoziModel) {
            let saved = results.find(x => x.store_id == store.id && x.flg_state != "1");
            if (saved && saved.id > 0) {
              store["smoid"] = saved.id;
            }
          }

          tp.negoziModel_previous = Object.assign([], tp.negoziModel);

          //se è attivo il pulsante "come emissione", allore riporta i cambiamenti anche in fruizione
          /*
          if(type == "E" && self.switch.offlineImportaComeEmissione){
            self.onChangeSwitchAsEmissionOff();
          }
          */

        });
      }

    }
  }
  createStoreObjectsForTouchpoints(type, online_offline) {
    /*** cambiamenti 09/12/2024 per gestione id di storemessageochannel ***/

    /*** scorro tutti i negozi per ogni touchpoint di tipo emissione o fruizione e online o offline
     * se incontro nella message instance un negozio con l'id che sto esaminando, allora metti quel negozio con flg_state = '0' e lo marco "visitato". Se non lo incontro, allora creo un nuovo record e lo marco visitato.
     * Infine scorro i negozi della messageInstance e metto tutti quelli non visitati, con flg_state = '1'
     * **/

    var self = this;
    for (let tp of this.touchpoints[type][online_offline]) {
      if (tp.active) {
        if (tp.negoziModel && tp.negoziModel.length > 0) {

          for (let store of tp.negoziModel) {
            /*** ***/
            let store_mi = self.messageInstanceObject.storeMessageOChannel.find(x => x.ochannelId == tp.ochannel_id && x.storeId == store.id && x.storeType == type);
            if (store_mi) {
              store_mi.flg_state = '0'
              store_mi["visited"] = true;
            }
            else { //se non ci sta nemmeno un record con flg_state = 0 o flg_state = 1, allora a questo punto crealo
              let smo = new StoreMessageOChannel();
              smo.storeId = store.id;
              smo.ochannelId = tp.ochannel_id;
              smo.storeType = type;
              smo.messageInstanceId = self.messageInstanceObject.id;
              smo.flg_state = '0';
              smo.visited = true;
              self.messageInstanceObject.storeMessageOChannel.push(smo);
            }
          }
        }
      }
    }

    for (let smo_mi of this.messageInstanceObject.storeMessageOChannel) {
      //scorro tutti i record e se ce ne sta qualcuno che non è stato "visitato" (cioè cambiato o creato), allora vuol dire che non devono far più parte e perciò gli metto flg_state = '1'
      if (!smo_mi.visited) {
        smo_mi["visited"] = true;
        smo_mi.flg_state = '1';
      }
    }

  }

  createStoreObjectsForTouchpoints_old(type) {

    var self = this;
    for (let tp of this.touchpoints[type].OFF) {
      if (tp.active) {
        if (tp.negoziModel && tp.negoziModel.length > 0) {

          for (let store of tp.negoziModel) {

            /*** cambiamenti 27/11/2024 per gestione id di storemessageochannel ***/
            let arrayObjectsInMessageInstance = self.messageInstanceObject.storeMessageOChannel.filter(x => x.ochannelId == tp.ochannel_id && x.storeId == store.id && x.storeType == type);

            if (arrayObjectsInMessageInstance && arrayObjectsInMessageInstance.length > 0) {

              //cade quì se nella message instance c'era già un record di quel negozio, su quel channel, di quel tipo (Emissione o Fruizione)

              //trova il record con flg_state = 0 con id più grande
              let obj_in_mi_state0 = arrayObjectsInMessageInstance.filter(x => x.flg_state == "0").reduce((prev, curr) => (prev === null || prev.id < curr.id ? curr : prev), null); // Trova quello con ID più grande
              if (obj_in_mi_state0) {
                //se ci sta ok non devo fare niente, ma lo marco visitato
                let obj = self.messageInstanceObject.storeMessageOChannel.find(x => x.id == obj_in_mi_state0.id)
                obj["visited"] = true;
              }
              else {

                //se non ci sta, allora trova quello con flg_state = 1 con id più grande e mettilo con flg_state = 0
                let obj_in_mi_state1 = arrayObjectsInMessageInstance.filter(x => x.flg_state == "1").reduce((prev, curr) => (prev === null || prev.id < curr.id ? curr : prev), null); // Trova quello con ID più grande

                if (obj_in_mi_state1) {
                  //metti flg_state = 0
                  let obj = self.messageInstanceObject.storeMessageOChannel.find(x => x.id == obj_in_mi_state1.id);
                  obj["visited"] = true;
                  obj.flg_state = "0";
                }
              }
            }
            else {
              //se non ci sta nemmeno un record con flg_state = 0 o flg_state = 1, allora a questo punto crealo
              let smo = new StoreMessageOChannel();
              smo.storeId = store.id;
              smo.ochannelId = tp.ochannel_id;
              smo.storeType = type;
              smo.messageInstanceId = self.messageInstanceObject.id;
              smo.flg_state = '0';
              smo.visited = true;
              self.messageInstanceObject.storeMessageOChannel.push(smo);
            }
          }
        }


        for (let smo_mi of this.messageInstanceObject.storeMessageOChannel) {
          //scorro tutti i record e se ce ne sta qualcuno che non è stato "visitato" (cioè cambiato o creato), allora vuol dire che non devono far più parte e perciò gli metto flg_state = '1'
          if (!smo_mi.visited && smo_mi.storeType == type) {
            smo_mi["visited"] = true;
            smo_mi.flg_state = '1';
          }
        }
      }
    }
  }

  //LO TENGO SOLO PERCHE' CI HO MESSO TANTO A SCRIVERLO, LA GESTIONE TUTTAVIA E' CAMBIATA, RIMUOVERE AL MOMENTO OPPORTUNO
  saveStoresForTouchpoints_OLD(type: string) {

    /*
    *  Per ogni touchpoint (solo per quelli offline, per quelli online non si definiscono negozi) verifica se ci sono state modifiche ai negozi.
    *  Se ci sono state modifiche allora fai una delete dei negozi "vecchi" e fai delle post per i negozi nuovi.
    *  Poi i touchpoint appena salvati diventeranno quelli "vecchi" per garantire continuità nelle future operazioni sui negozi.
    */

    for (let tp of this.touchpoints[type].OFF) {

      if (tp.active && tp.negoziModified == true) {
        //negozi modificati

        const observablesDelete: Observable<any>[] = [];
        const observablesAdd: Observable<any>[] = [];

        //faccio prima un array di observables per le DELETE dei negozi vecchi (se esistenti)
        if (tp.negoziModel_previous && tp.negoziModel_previous.length > 0) {

          for (let store of tp.negoziModel_previous) {
            if (store.smoid > 0) {
              const observableDel = this.srvCampaign3.deteleTouchpointStores(store.smoid);
              observablesDelete.push(observableDel);
            }
          }

          //a questo punto effettuo le chiamate
          Observable.zip(...observablesDelete).subscribe(results => {
            if (!results) {

              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.error_saving_touchpoint_stores')
              });



            }
            else {

              //dopo la delete faccio un array di observables per la POST per aggiungere i negozi nuovi
              if (tp.negoziModel && tp.negoziModel.length > 0) {
                if (tp.negoziModel && tp.negoziModel.length > 0) {
                  for (let store of tp.negoziModel) {
                    const observableAdd = this.srvCampaign3.saveTouchpointStores(this.messageInstanceObject.id,
                      tp.ochannel_id,
                      type, store.id);
                    observablesAdd.push(observableAdd);
                  }
                }
              }

              //a questo punto effettuo le chiamate add
              Observable.zip(...observablesAdd).subscribe(resultsAdd => {
                if (!resultsAdd) {
                  console.log(JSON.stringify(resultsAdd));

                  this.srvNotify.add({
                    severity: 'error',
                    summary: this.translate.instant('common.error'),
                    detail: this.translate.instant('campaign.error_saving_touchpoint_stores')
                  });



                }

                for (let store of tp.negoziModel) {
                  let saved = resultsAdd.find(x => x.store_id == store.id && x.flg_state != "1");
                  if (saved && saved.id > 0) {
                    store["smoid"] = saved.id;
                  }
                }

                tp.negoziModel_previous = Object.assign([], tp.negoziModel);

                //se è attivo il pulsante "come emissione", allore riporta i cambiamenti anche in fruizione
                /*
                if(type == "E" && self.switch.offlineImportaComeEmissione){
                  self.onChangeSwitchAsEmissionOff();
                }
                */

              });
            }
          });
        }
        else {
          //caso solo add, senza delete
          // faccio un array di observables per la POST per aggiungere i negozi nuovi
          if (tp.negoziModel && tp.negoziModel.length > 0) {
            if (tp.negoziModel && tp.negoziModel.length > 0) {
              for (let store of tp.negoziModel) {
                const observableAdd = this.srvCampaign3.saveTouchpointStores(this.messageInstanceObject.id,
                  tp.ochannel_id,
                  type, store.id);
                observablesAdd.push(observableAdd);
              }
            }
          }

          //a questo punto effettuo le chiamate add
          Observable.zip(...observablesAdd).subscribe(resultsAdd => {
            if (!resultsAdd) {

              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.error_saving_touchpoint_stores')
              });



            }

            for (let store of tp.negoziModel) {
              let saved = resultsAdd.find(x => x.store_id == store.id && x.flg_state != "1");
              if (saved && saved.id > 0) {
                store["smoid"] = saved.id;
              }
            }

            tp.negoziModel_previous = Object.assign([], tp.negoziModel);

            //se è attivo il pulsante "come emissione", allore riporta i cambiamenti anche in fruizione
            /*
            if(type == "E" && self.switch.offlineImportaComeEmissione){
              self.onChangeSwitchAsEmissionOff();
            }
            */

          });
        }


      }

    }
  }

  anteprimaCoupon(tp: any) {
    let ochannel_id = tp.ochannel_id;
    var self = this;
    this.srvCampaign3.anteprimaCoupon_V2(ochannel_id, this.messageInstanceObject.id).subscribe(res => {

      if (res && res.risposta && res.risposta.codiceEsito == "OK" && res.oggetto) {
        self.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64, ' + res.oggetto);
        self.showPreviewError = null;
        self.showPreview = true;

        // self.srvNotify.add({severity: 'error', summary: 'Error', detail: 'Codice Esito: ' + res.risposta.codiceEsito+ " - " + res.risposta.descrizioneEsito });
      }
      else {
        if (res.risposta.descrizioneEsito) {
          self.showPreviewError = res.risposta.descrizioneEsito;
          self.showPreview = true;
        }
        else {

          self.srvNotify.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('campaign.error_retrieving_coupon_preview')
          });



        }
      }
    })



  }
  //Creata la refola "provvisioria" la salviamo nei vari "rules_TR_fruition" o "rules_TR_emission"
  //a differenza degli altri tipi di regola che vengono popolati solo quando confermo il salvataggio dell'oggettone
  //qui saranno popolati alla conferma del popup. Durante il dalvataggio dell'oggettone verranno semplicemente recuperate e aggiunte all'oggetto
   onRulesCreated_old(rules: MessageInstanceRule[]) {
    if (!rules || !rules.length) return;

    const rule = rules[0];
    console.log('Regola ricevuta dal figlio:', rule);

    let targetArray: MessageInstanceRule[];

    if (rule.ruleScope === 'emission') {
      targetArray = this.rules_TR_emission;
    } else if (rule.ruleScope === 'fruition') {
      targetArray = this.rules_TR_fruition;
    } else {
      console.warn('Scope non gestito:', rule.ruleScope);
      return;
    }

    const existingIndex = targetArray.findIndex(r => r.ochannelId === rule.ochannelId);

    if (!rule.messageInstanceRuleDetail || rule.messageInstanceRuleDetail.length === 0) {
      // Se non ci sono dettagli, rimuovo la regola esistente (se c'è)
      if (existingIndex !== -1) {
        targetArray.splice(existingIndex, 1);
      }
    } else {
      // Altrimenti aggiorno o inserisco
      if (existingIndex !== -1) {
        targetArray[existingIndex] = rule;
      } else {
        targetArray.push(rule);
      }
    }

    // Aggancio anche dentro i touchpoint
    const status = rule.touchpointTarget === 'ON' ? 'ON' : 'OFF';
    const scope = rule.ruleScope === 'emission' ? 'E' : (rule.ruleScope == "fruition" ? "F" : "");

    if (this.touchpoints[scope] && this.touchpoints[scope][status]) {
      const tpIndex = this.touchpoints[scope][status]
        .findIndex(r => r.ochannelId === rule.ochannelId);

      if (!rule.messageInstanceRuleDetail || rule.messageInstanceRuleDetail.length === 0) {
        // rimuovo dal touchpoint se la regola non ha dettagli
        if (tpIndex !== -1) {
          this.touchpoints[scope][status].splice(tpIndex, 1);
        }
      } else {
        if (tpIndex !== -1) {
          this.touchpoints[scope][status][tpIndex] = rule;
        } else {
          this.touchpoints[scope][status].push(rule);
        }
      }
    }

    console.log('emission', this.rules_TR_emission);
    console.log('fruition', this.rules_TR_fruition);
    console.log('touchpoints', this.touchpoints);

    this.show.modalForRules = !this.show.modalForRules;
  }
 //KS-7646 permesso la creazione di regole nulle
 //TODO dubbi su come si comporta in caso di emissione con molte regole


onRulesCreated(rules: MessageInstanceRule[]) {
  // Se non ci sono regole, considero l’array come vuoto (serve per "cancellazione")
  if (!rules) {
    rules = [];
  }

  // 🧹 Caso: cancellazione di regole per un touchpoint specifico
  if (rules.length === 0) {
    // Recupero lo scope e l’ochannelId dal contesto o da variabili locali
    // (lo scope può essere this.scope o passato dal figlio)
    const scopeToClear = this.futureScopeRule === 'emission' ? 'emission' : 'fruition';
    const oChannelIdToRemove = this.touchpointid; // touchpoint corrente

    console.log(`Nessuna regola ricevuta, rimuovo solo regola touchpoint ${oChannelIdToRemove} in ${scopeToClear}`);

    let targetArray: MessageInstanceRule[];

    if (scopeToClear === 'emission') {
      targetArray = this.rules_TR_emission;
    } else {
      targetArray = this.rules_TR_fruition;
    }

    // 🔸 Rimuovi solo le regole relative a quel touchpoint
    const index = targetArray.findIndex(r => r.ochannelId === oChannelIdToRemove);
    if (index !== -1) {
      targetArray.splice(index, 1);
    }

    // 🔸 Pulisci anche nei touchpoints
    const scopeKey = scopeToClear === 'emission' ? 'E' : 'F';
    ['ON', 'OFF'].forEach(status => {
      if (this.touchpoints[scopeKey] && this.touchpoints[scopeKey][status]) {
        const tpIndex = this.touchpoints[scopeKey][status]
          .findIndex(r => r.ochannelId === oChannelIdToRemove);
        if (tpIndex !== -1) {
          this.touchpoints[scopeKey][status].splice(tpIndex, 1);
        }
      }
    });

    console.log('Dopo rimozione:');
    console.log('emission', this.rules_TR_emission);
    console.log('fruition', this.rules_TR_fruition);
    console.log('touchpoints', this.touchpoints);

    this.show.modalForRules = !this.show.modalForRules;
    return;
  }

  // 🧩 Caso: ho almeno una regola valida
  const rule = rules[0];
  console.log('Regola ricevuta dal figlio:', rule);

  let targetArray: MessageInstanceRule[];

  if (rule.ruleScope === 'emission') {
    targetArray = this.rules_TR_emission;
  } else if (rule.ruleScope === 'fruition') {
    targetArray = this.rules_TR_fruition;
  } else {
    console.warn('Scope non gestito:', rule.ruleScope);
    return;
  }

  const existingIndex = targetArray.findIndex(r => r.ochannelId === rule.ochannelId);

  if (!rule.messageInstanceRuleDetail || rule.messageInstanceRuleDetail.length === 0) {
    // Se non ci sono dettagli, rimuovo la regola esistente (se c’è)
    if (existingIndex !== -1) {
      targetArray.splice(existingIndex, 1);
    }
  } else {
    // Altrimenti aggiorno o inserisco
    if (existingIndex !== -1) {
      targetArray[existingIndex] = rule;
    } else {
      targetArray.push(rule);
    }
  }

  // Aggancio anche dentro i touchpoint
  const status = rule.touchpointTarget === 'ON' ? 'ON' : 'OFF';
  const scope = rule.ruleScope === 'emission' ? 'E' : (rule.ruleScope === 'fruition' ? 'F' : '');

  if (this.touchpoints[scope] && this.touchpoints[scope][status]) {
    const tpIndex = this.touchpoints[scope][status]
      .findIndex(r => r.ochannelId === rule.ochannelId);

    if (!rule.messageInstanceRuleDetail || rule.messageInstanceRuleDetail.length === 0) {
      if (tpIndex !== -1) {
        this.touchpoints[scope][status].splice(tpIndex, 1);
      }
    } else {
      if (tpIndex !== -1) {
        this.touchpoints[scope][status][tpIndex] = rule;
      } else {
        this.touchpoints[scope][status].push(rule);
      }
    }
  }

  console.log('emission', this.rules_TR_emission);
  console.log('fruition', this.rules_TR_fruition);
  console.log('touchpoints', this.touchpoints);

  this.show.modalForRules = !this.show.modalForRules;
}



  hasRules(scope: 'emission' | 'fruition', tpid: number): boolean {

    let rules: any[] = [];
    if (scope === 'emission') {
      rules = this.rules_TR_emission || [];
    } else if (scope === 'fruition') {
      rules = this.rules_TR_fruition || [];
    }

    let found = rules.find(x=>x.ruleScope == scope && x.ochannelId == tpid);

    if(found) return true;
    else return false;
  }


confirmResetTouchpoint(type: string, online_offline: string, index: number) {
  this.confirmationService.confirm({
    key: 'resetDialog',
    message: this.translate.instant('campaign.confirm_reset_layout_message'),
    header: this.translate.instant('common.confirm'),
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      this.onClickResetTouchpoint(type, online_offline, index);
    }
  });
}

// TODO TEST
onClickResetTouchpoint(type: string, online_offline: string, index: number) {
  const tp = this.touchpoints[type][online_offline][index];

  // azzera layout
  tp.layoutValue = null;
  tp.layoutOwnSet = false;
  tp.layoutDefaultSet = false;
}

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-touchpoint/campaign-3-touchpoint.component.ts